// Open BModals, the last opened on top: Escape only closes the top one, not every modal under it
const openModals: string[] = []

export const closeModal = (id: string) => {
  const index = openModals.indexOf(id)
  if (index !== -1)
    openModals.splice(index, 1)
}

export const openModal = (id: string) => {
  closeModal(id)
  openModals.push(id)
}

export const isTopModal = (id: string) => openModals[openModals.length - 1] === id
